import * as React from 'react';
import { useDispatch } from 'react-redux';
import DataColumn from '../../components/controls/datagrid/DataColumn';
import DataList from '../../components/controls/datagrid/DataList';
import { setOperation } from '../operation/operationSlice';

export default (props: { controller: string, items: any }) => {
    const dispatch = useDispatch()
    const onRowClick = (e: any, data: any) => {
        e.preventDefault()
        dispatch(setOperation("read", props.controller, { index: data }))
    }

    return (
        <>
            <DataList items={props.items} onRowClick={onRowClick} >
                <DataColumn kid='column1' name='Codice' fieldName='code' minWidth={100} maxWidth={100} align='left' />
                <DataColumn kid='column2' name='Nome' fieldName='firstname' minWidth={150} maxWidth={300} align='left' />
                <DataColumn kid='column3' name='Cognome' fieldName='lastname' minWidth={150} maxWidth={300} align='left' />
                <DataColumn kid='column4' name='E-Mail' fieldName='email' minWidth={150} align='left' />
            </DataList>
        </>
    );
}
